import React from "react";

const FilterIcon = ({ width, height, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.06875 15.0046C4.45613 13.9067 5.17451 12.956 6.12488 12.2836C7.07524 11.6111 8.21079 11.25 9.375 11.25C10.5392 11.25 11.6748 11.6111 12.6251 12.2836C13.5755 12.956 14.2939 13.9067 14.6813 15.0046H30V18.7546H14.6813C14.2939 19.8525 13.5755 20.8032 12.6251 21.4756C11.6748 22.1481 10.5392 22.5092 9.375 22.5092C8.21079 22.5092 7.07524 22.1481 6.12488 21.4756C5.17451 20.8032 4.45613 19.8525 4.06875 18.7546H0V15.0046H4.06875ZM15.3187 3.7546C15.7061 2.65672 16.4245 1.70603 17.3749 1.03357C18.3252 0.361117 19.4608 0 20.625 0C21.7892 0 22.9248 0.361117 23.8751 1.03357C24.8255 1.70603 25.5439 2.65672 25.9313 3.7546H30V7.5046H25.9313C25.5439 8.60247 24.8255 9.55316 23.8751 10.2256C22.9248 10.8981 21.7892 11.2592 20.625 11.2592C19.4608 11.2592 18.3252 10.8981 17.3749 10.2256C16.4245 9.55316 15.7061 8.60247 15.3187 7.5046H0V3.7546H15.3187ZM20.625 7.5046C21.1223 7.5046 21.5992 7.30705 21.9508 6.95542C22.3025 6.60379 22.5 6.12688 22.5 5.6296C22.5 5.13231 22.3025 4.6554 21.9508 4.30377C21.5992 3.95214 21.1223 3.7546 20.625 3.7546C20.1277 3.7546 19.6508 3.95214 19.2992 4.30377C18.9475 4.6554 18.75 5.13231 18.75 5.6296C18.75 6.12688 18.9475 6.60379 19.2992 6.95542C19.6508 7.30705 20.1277 7.5046 20.625 7.5046ZM9.375 18.7546C9.87228 18.7546 10.3492 18.5571 10.7008 18.2054C11.0525 17.8538 11.25 17.3769 11.25 16.8796C11.25 16.3823 11.0525 15.9054 10.7008 15.5538C10.3492 15.2021 9.87228 15.0046 9.375 15.0046C8.87772 15.0046 8.4008 15.2021 8.04917 15.5538C7.69754 15.9054 7.5 16.3823 7.5 16.8796C7.5 17.3769 7.69754 17.8538 8.04917 18.2054C8.4008 18.5571 8.87772 18.7546 9.375 18.7546Z"
      transform="translate(0 .998)"
      fill="#606F7B"
    />
  </svg>
);

export default FilterIcon;



// WEBPACK FOOTER //
// ../shop_main/images/filterIcon.js